<template>
    <div class="demo-container">
        <div class="demo" :data-noscroll="overlayPanel?true:false" :data-guided="guidedMode" :data-show-links="showLinks">

            <div class="screens" ref="screens">

                <!-- DASHBOARD -->
                <div class="screen" data-screen="dashboard" :data-active="currentScreen=='dashboard'">
                    <img class="w-full max-w-100" src="/img/screens/admin-dashboard.png" />
                    <div class="links">



                        <screen-link left="47.25%" top="61.75%" width="19.75%" height="5.25%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>




                    </div>
                </div>

              <div class="screen" data-screen="dashboard-tasks" :data-active="currentScreen=='dashboard-tasks'">
                <img class="w-full max-w-100" src="/img/screens/admin-dashboard-tasks.png" />
                <div class="links">
                  <screen-link left="15%" top="13.5%" width="8%" height="5%" data-tgt="dashboard" @click.native="onLinkClick"></screen-link>
                  <screen-link left="47.25%" top="53.5%" width="19.75%" height="5%" data-tgt="dashboard-tasks-feedback" @click.native="onLinkClick"></screen-link>
                  <screen-link left="90.75%" top="17.75%" width="8.75%" height="6%" data-tgt="dashboard-tasks-options" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="dashboard-tasks-options" :data-active="currentScreen=='dashboard-tasks-options'">
                <img class="w-full max-w-100" src="/img/screens/admin-dashboard-tasks-options.png" />
                <div class="links">
                  <screen-link left="15%" top="13.5%" width="8%" height="5%" data-tgt="dashboard" @click.native="onLinkClick"></screen-link>
                  <screen-link left="47.25%" top="53.5%" width="19.75%" height="5%" data-tgt="dashboard-tasks-feedback" @click.native="onLinkClick"></screen-link>
                  <screen-link left="96.5%" top="18.75%" width="3%" height="5%" data-tgt="dashboard-tasks" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83.5%" top="22.5%" width="11%" height="5%" data-tgt="dashboard-approvals-history" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="dashboard-approvals-history" :data-active="currentScreen=='dashboard-approvals-history'">
                <img class="w-full max-w-100" src="/img/screens/admin-dashboard-approvals-history.png" />
                <div class="links">
                  <screen-link left="15%" top="13.5%" width="6%" height="5%" data-tgt="dashboard-tasks" @click.native="onLinkClick"></screen-link>
                  <screen-link left="15%" top="23%" width="4%" height="4%" data-tgt="dashboard-approvals-requests" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="dashboard-approvals-requests" :data-active="currentScreen=='dashboard-approvals-requests'">
                <img class="w-full max-w-100" src="/img/screens/admin-dashboard-approvals-requests.png" />
                <div class="links">
                  <screen-link left="15%" top="13.5%" width="6%" height="5%" data-tgt="dashboard-tasks" @click.native="onLinkClick"></screen-link>
                  <screen-link left="19.25%" top="23%" width="4%" height="4%" data-tgt="dashboard-approvals-history" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="dashboard-tasks-feedback" :data-active="currentScreen=='dashboard-tasks-feedback'">
                <img class="w-full max-w-100" src="/img/screens/admin-dashboard-tasks-feedback.png" />
                <div class="links">
                  <screen-link left="52.5%" top="54.5%" width="5.75%" height="5%" data-tgt="dashboard-tasks" @click.native="onLinkClick"></screen-link>
                </div>
              </div>


                <!-- OVERVIEW -->
                <div class="screen" data-screen="hb-overview" :data-active="currentScreen=='hb-overview'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="5.4%" height="3%" data-tgt="hb-employees-all" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>


                        <screen-link left="68%" top="49.5%" width="19%" height="10%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                        <screen-link left="68%" top="61.5%" width="19%" height="10%" data-tgt="hb-overview-documents" @click.native="onLinkClick"></screen-link>
                        <screen-link left="68%" top="73.5%" width="19%" height="10%" data-tgt="hb-overview-compliance" @click.native="onLinkClick"></screen-link>

                      <screen-link left="38%" top="66%" width="19%" height="4%" data-tgt="hb-employees-annual" @click.native="onLinkClick"></screen-link>
                      <screen-link left="38%" top="99%" width="19%" height="4%" data-tgt="hb-employees-newly" @click.native="onLinkClick"></screen-link>
                      <screen-link left="38%" top="141%" width="19%" height="4%" data-tgt="hb-employees-current" data-tgt-scrolltop="true" @click.native="onLinkClick"></screen-link>



                    </div>
                </div>

                <div class="screen" data-screen="hb-overview-billing" :data-active="currentScreen=='hb-overview-billing'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-billing.png" />
                    <div class="links">

                        <screen-link left="64%" top="21%" width="9%" height="5%" data-tgt="hb-overview-billing-statement" @click.native="onLinkClick"></screen-link>

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>



              <div class="screen z-max" data-screen="hb-overview-billing-statement" :data-active="currentScreen=='hb-overview-billing-statement'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-billing-statement-8-2020.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-overview-billing" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

                <!-- REPORTS -->

                <div class="screen" data-screen="hb-overview-reports" :data-active="currentScreen=='hb-overview-reports'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="14.5%" width="30%" height="4%" data-tgt="hb-overview-reports-search" @click.native="onLinkClick"></screen-link>
                        <screen-link left="62.5%" top="18.5%" width="8%" height="3.5%" data-tgt="hb-overview-reports-outputs" @click.native="onLinkClick"></screen-link>

                        <screen-link left="63.2%" top="82%" width="35.5%" height="10%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63.2%" top="61.5%" width="35.5%" height="12%" data-tgt="hb-overview-reports-EEDS" @click.native="onLinkClick"></screen-link>


                    </div>
                </div>

                <div class="screen" data-screen="hb-overview-reports-outputs" :data-active="currentScreen=='hb-overview-reports-outputs'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-outputs-popup.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="14.5%" width="30%" height="4%" data-tgt="hb-overview-reports-search" @click.native="onLinkClick"></screen-link>
                        <screen-link left="80.5%" top="18.5%" width="2.5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>

                        <screen-link left="63.2%" top="82%" width="35.5%" height="10%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63.2%" top="61.5%" width="35.5%" height="12%" data-tgt="hb-overview-reports-EEDS" @click.native="onLinkClick"></screen-link>


                    </div>
                </div>

                <div class="screen" data-screen="hb-overview-reports-search" :data-active="currentScreen=='hb-overview-reports-search'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-search-ESR.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="93.5%" top="14.5%" width="5.5%" height="4%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>






                    </div>
                </div>

                <div class="screen" data-screen="hb-overview-reports-search-results" :data-active="currentScreen=='hb-overview-reports-search-results'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-search-ESR-results.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                      <screen-link left="90.75%" top="19.5%" width="2.0%" height="3.5%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>


                      <screen-link left="63.2%" top="66%" width="35.5%" height="30%" data-tgt="hb-overview-reports-ESR-client" @click.native="onLinkClick"></screen-link>
                      <screen-link left="63.2%" top="97%" width="35.5%" height="20%" data-tgt="hb-overview-reports-ESR-summary" @click.native="onLinkClick"></screen-link>
                      <screen-link left="63.2%" top="117.5%" width="35.5%" height="29%" data-tgt="hb-overview-reports-ESR-large-employer" @click.native="onLinkClick"></screen-link>






                    </div>
                </div>



              <div class="screen" data-screen="hb-overview-reports-ESR-client" :data-active="currentScreen=='hb-overview-reports-ESR-client'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>

                  <screen-link left="70%" top="16.5%" width="8.5%" height="5%" data-tgt="hb-overview-reports-ESR-client-custom" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="70%" width="35%" height="4%" data-tgt="hb-overview-reports-ESR-client-select-download" @click.native="onLinkClick"></screen-link>



                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-ESR-client-custom" :data-active="currentScreen=='hb-overview-reports-ESR-client-custom'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client-custom.png" />
                <div class="links">

                  <screen-link left="86%" top="7.25%" width="5.75%" height="4.5%" data-tgt="hb-overview-reports-ESR-client" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91.9%" top="7.25%" width="7.1%" height="4.5%" data-tgt="hb-overview-reports-ESR-client-custom-built" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-ESR-client-custom-built" :data-active="currentScreen=='hb-overview-reports-ESR-client-custom-built'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client-custom-built.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>

                  <screen-link left="70%" top="16.5%" width="8.5%" height="5%" data-tgt="hb-overview-reports-ESR-client-custom" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="70%" width="35%" height="4%" data-tgt="hb-overview-reports-ESR-client-custom-select-download" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-ESR-client-custom-built-select" :data-active="currentScreen=='hb-overview-reports-ESR-client-custom-built-select'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client-custom-built-select.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>

                  <screen-link left="70%" top="16.5%" width="8.5%" height="5%" data-tgt="hb-overview-reports-ESR-client-custom" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="70%" width="3%" height="4%" data-tgt="hb-overview-reports-ESR-client-custom-built" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="52.5%" width="8%" height="5%" data-tgt="hb-overview-reports-ESR-client-custom-select-download" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-ESR-client-select" :data-active="currentScreen=='hb-overview-reports-ESR-client-select'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client-select.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>

                  <screen-link left="70%" top="16.5%" width="8.5%" height="5%" data-tgt="hb-overview-reports-ESR-client-custom" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="70%" width="3%" height="4%" data-tgt="hb-overview-reports-ESR-client" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="52.5%" width="8%" height="5%" data-tgt="hb-overview-reports-ESR-client-select-download" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen z-max" data-screen="hb-overview-reports-ESR-client-select-download" :data-active="currentScreen=='hb-overview-reports-ESR-client-select-download'">
                <img class="w-full max-w-100" src="/img/screens/esr-client-report-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-overview-reports-ESR-client" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen z-max" data-screen="hb-overview-reports-ESR-summary" :data-active="currentScreen=='hb-overview-reports-ESR-summary'">
                <img class="w-full max-w-100" src="/img/screens/esr-summary-report.png" />
                <div class="links">

                  <screen-link left="15%" top="2%" width="5%" height="5%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen z-max" data-screen="hb-overview-reports-ESR-large-employer" :data-active="currentScreen=='hb-overview-reports-ESR-large-employer'">
                <img class="w-full max-w-100" src="/img/screens/esr-large-employer-report.png" />
                <div class="links">

                  <screen-link left="5%" top="2%" width="5%" height="5%" data-tgt="hb-overview-reports-search-results" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen z-max" data-screen="hb-overview-reports-ESR-client-custom-select-download" :data-active="currentScreen=='hb-overview-reports-ESR-client-custom-select-download'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-ESR-client-select-download.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-overview-reports-ESR-client-custom-built" @click.native="onLinkClick"></screen-link>


                </div>
              </div>



              <div class="screen" data-screen="hb-overview-reports-census" :data-active="currentScreen=='hb-overview-reports-census'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                      <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                      <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-description" @click.native="onLinkClick"></screen-link>


                      <screen-link left="62.5%" top="41%" width="37%" height="6%" data-tgt="hb-overview-reports-census-pdf" @click.native="onLinkClick"></screen-link>

                    </div>
                </div>

              <div class="screen z-max" data-screen="hb-overview-reports-census-pdf" :data-active="currentScreen=='hb-overview-reports-census-pdf'">
                <img class="w-full max-w-100" src="/img/screens/census_report_pdf.png" />
                <div class="links">


                  <screen-link left="1%" top="1%" width="98%" height="290%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-check" :data-active="currentScreen=='hb-overview-reports-census-check'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-check.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-description-check" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="42%" width="2.5%" height="4%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="24.75%" width="8%" height="5%" data-tgt="hb-overview-reports-census-download" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-description" :data-active="currentScreen=='hb-overview-reports-census-description'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-description.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="47.5%" width="2.5%" height="4%" data-tgt="hb-overview-reports-census-description-check" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-description-check" :data-active="currentScreen=='hb-overview-reports-census-description-check'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-description-check.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-check" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="47.5%" width="2.5%" height="4%" data-tgt="hb-overview-reports-census-description" @click.native="onLinkClick"></screen-link>

                  <screen-link left="63%" top="30.25%" width="8%" height="5%" data-tgt="hb-overview-reports-census-download" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-create" :data-active="currentScreen=='hb-overview-reports-census-create'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-create-filled.png" />
                <div class="links">

                  <screen-link left="86%" top="7.25%" width="5.75%" height="4.5%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91.9%" top="7.25%" width="7.1%" height="4.5%" data-tgt="hb-overview-reports-census-created" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-created" :data-active="currentScreen=='hb-overview-reports-census-created'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-created.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="47.5%" width="2.5%" height="4%" data-tgt="hb-overview-reports-census-created-check" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-census-created-check" :data-active="currentScreen=='hb-overview-reports-census-created-check'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-created-selected.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census-create" @click.native="onLinkClick"></screen-link>
                  <screen-link left="83%" top="12.2%" width="7.9%" height="4%" data-tgt="hb-overview-reports-census" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="47.5%" width="2.5%" height="4%" data-tgt="hb-overview-reports-census-created" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="30.25%" width="8%" height="5%" data-tgt="hb-overview-reports-census-created-download" @click.native="onLinkClick"></screen-link>
                  <screen-link left="71.25%" top="30.25%" width="10%" height="5%" data-tgt="hb-overview-reports-census-description" @click.native="onLinkClick"></screen-link>

                </div>
              </div>


              <div class="screen z-max" data-screen="hb-overview-reports-census-download" :data-active="currentScreen=='hb-overview-reports-census-download'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-created-download.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-overview-reports-census-check" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen z-max" data-screen="hb-overview-reports-census-created-download" :data-active="currentScreen=='hb-overview-reports-census-created-download'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-census-created-download.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-overview-reports-census-created-check" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

                <div class="screen" data-screen="hb-overview-reports-EEDS" :data-active="currentScreen=='hb-overview-reports-EEDS'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-EEDS.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>

                      <screen-link left="62.5%" top="46%" width="37%" height="6%" data-tgt="hb-overview-reports-EEDS-pdf" @click.native="onLinkClick"></screen-link>

                    </div>
                </div>

              <div class="screen z-max" data-screen="hb-overview-reports-EEDS-pdf" :data-active="currentScreen=='hb-overview-reports-EEDS-pdf'">
                <img class="w-full max-w-100" src="/img/screens/EEDS_pdf.png" />
                <div class="links">



                  <screen-link left="1%" top="1%" width="98%" height="185%" data-tgt="hb-overview-reports-EEDS" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-EEDS-description" :data-active="currentScreen=='hb-overview-reports-EEDS-description'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-EEDS-description.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62.5%" top="7.5%" width="5%" height="4%" data-tgt="hb-overview-reports" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="17.6%" width="7.5%" height="3%" data-tgt="hb-overview-reports-EEDS" @click.native="onLinkClick"></screen-link>
                  <screen-link left="70.5%" top="17%" width="7.5%" height="4%" data-tgt="hb-overview-reports-EEDS-custom" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-overview-reports-EEDS-custom" :data-active="currentScreen=='hb-overview-reports-EEDS-custom'">
                <img class="w-full max-w-100" src="/img/screens/hb-overview-reports-EEDS-custom.png" />
                <div class="links">


                  <screen-link left="86%" top="7.25%" width="5.75%" height="4.5%" data-tgt="hb-overview-reports-EEDS" @click.native="onLinkClick"></screen-link>

                </div>
              </div>


              <!-- DOCUMENTS -->

                <div class="screen" data-screen="hb-overview-documents" :data-active="currentScreen=='hb-overview-documents'">
                    <img class="w-full max-w-100" src="/img/screens/hb-overview-documents.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63.2%" top="15%" width="35.5%" height="13.5%" data-tgt="hb-overview-documents-handbook" @click.native="onLinkClick"></screen-link>

                    </div>
                </div>

                <div class="screen z-max" data-screen="hb-overview-documents-handbook" :data-active="currentScreen=='hb-overview-documents-handbook'">
                    <img class="w-full max-w-100" src="/img/screens/guidebook-pdf.png" />
                    <div class="links">

                        <screen-link left="0" top="0" width="100%" height="115%" data-tgt="hb-overview-documents" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <div class="screen z-max" data-screen="hb-overview-compliance" :data-active="currentScreen=='hb-overview-compliance'">
                    <img class="w-full max-w-100" src="/img/screens/compliance-page2-pdf.png" />
                    <div class="links">

                        <screen-link left="0" top="0" width="100%" height="230%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <!-- EMPLOYEES -->
                <div class="screen" data-screen="hb-employees-all" :data-active="currentScreen=='hb-employees-all'">
                    <img class="w-full max-w-100" src="/img/screens/hb-employees-all.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                        <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                        <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                        <screen-link left="26.5%" top="47.5%" width="61%" height="7.5%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
                      <screen-link left="26.5%" top="100.5%" width="61%" height="7.5%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
                        <select-box selection="All Employees" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>


                    </div>

                </div>

              <div class="screen" data-screen="hb-employees-newly" :data-active="currentScreen=='hb-employees-newly'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-newly-eligible.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="55%" height="7.5%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
                  <screen-link left="85%" top="40.5%" width="2.5%" height="7.5%" data-tgt="hb-employees-newly-eligible-options" @click.native="onLinkClick"></screen-link>

                  <select-box selection="Newly Eligible" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>

              <div class="screen" data-screen="hb-employees-newly-eligible-options" :data-active="currentScreen=='hb-employees-newly-eligible-options'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-newly-eligible-options.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="40%" height="7.5%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
                  <screen-link left="76%" top="42.5%" width="10%" height="5%" data-tgt="hb-enrollment-begin" data-tgt-mode="employee" @click.native="onLinkClick"></screen-link>
                  <screen-link left="76%" top="53%" width="10%" height="6%" data-tgt="hb-enrollment-kit" @click.native="onLinkClick"></screen-link>

                  <select-box selection="Newly Eligible" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>

              <div class="screen z-max" data-screen="hb-enrollment-kit" :data-active="currentScreen=='hb-enrollment-kit'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-newly-eligible-enrollment-kit.png" />
                <div class="links">
                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-employees-newly" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-employees-annual" :data-active="currentScreen=='hb-employees-annual'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-annual.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>

                  <screen-link left="26.5%" top="40.5%" width="55%" height="7.5%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>


                  <select-box selection="Annual Enrollment" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>

              <div class="screen" data-screen="hb-employees-current" :data-active="currentScreen=='hb-employees-current'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-current.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="50%" height="7.5%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
                  <screen-link left="85%" top="40.5%" width="2.5%" height="7.5%" data-tgt="hb-employees-current-terri-expanded" @click.native="onLinkClick"></screen-link>

                  <select-box selection="Current Enrollment" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>


                </div>

              </div>

              <div class="screen" data-screen="hb-employees-current-terri-expanded" :data-active="currentScreen=='hb-employees-current-terri-expanded'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-current-terri-expanded.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="50%" height="7.5%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
                  <screen-link left="85%" top="40.5%" width="2.5%" height="7.5%" data-tgt="hb-employees-current" @click.native="onLinkClick"></screen-link>

                  <select-box selection="Current Enrollment" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>

              <div class="screen" data-screen="hb-employees-future" :data-active="currentScreen=='hb-employees-future'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-future.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>


                  <select-box selection="Future Enrollment" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>


                </div>

              </div>

              <div class="screen" data-screen="hb-employees-future-gail-expanded" :data-active="currentScreen=='hb-employees-future-gail-expanded'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-future-gail-expanded.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                  <screen-link left="73.6%" top="30.8%" width="6.5%" height="5%" data-tgt="hb-employees-filters" @click.native="onLinkClick" class="hidden"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="50%" height="7.5%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
                  <screen-link left="85%" top="40.5%" width="2.5%" height="7.5%" data-tgt="hb-employees-future" @click.native="onLinkClick"></screen-link>


                  <select-box selection="Future Enrollment" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing" :data-active="currentScreen=='hb-employees-missing'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="61%" height="7.5%" data-tgt="hb-employees-missing-tonia" @click.native="onLinkClick"></screen-link>


                  <select-box selection="Missing Information" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>
                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing-tonia" :data-active="currentScreen=='hb-employees-missing-tonia'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing-tonia.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-employees-missing" @click.native="onLinkClick"></screen-link>
                  <screen-link left="92%" top="32%" width="6%" height="5%" data-tgt="hb-employees-missing-tonia-edit" @click.native="onLinkClick"></screen-link>
                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing-tonia-edit" :data-active="currentScreen=='hb-employees-missing-tonia-edit'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing-tonia-edit.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-employees-missing" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62%" top="7.5%" width="10%" height="4%" data-tgt="hb-employees-missing-tonia" @click.native="onLinkClick"></screen-link>
                  <screen-link left="64%" top="32%" width="34%" height="8%" data-tgt="hb-employees-missing-tonia-edit-filled" @click.native="onLinkClick"></screen-link>
                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing-tonia-edit-filled" :data-active="currentScreen=='hb-employees-missing-tonia-edit-filled'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing-tonia-edit-filled.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-employees-missing" @click.native="onLinkClick"></screen-link>
                  <screen-link left="62%" top="7.5%" width="10%" height="4%" data-tgt="hb-employees-missing-tonia" @click.native="onLinkClick"></screen-link>
                  <screen-link left="88%" top="12%" width="5%" height="4.5%" data-tgt="hb-employees-missing-tonia" @click.native="onLinkClick"></screen-link>
                  <screen-link left="93.5%" top="12%" width="5.5%" height="4.5%" data-tgt="hb-employees-missing-tonia-edit-confirmed" @click.native="onLinkClick"></screen-link>
                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing-tonia-edit-confirmed" :data-active="currentScreen=='hb-employees-missing-tonia-edit-confirmed'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing-tonia-edit-confirmed.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-employees-missing-tonia-edited" @click.native="onLinkClick"></screen-link>

                </div>

              </div>

              <div class="screen" data-screen="hb-employees-missing-tonia-edited" :data-active="currentScreen=='hb-employees-missing-tonia-edited'">
                <img class="w-full max-w-100" src="/img/screens/hb-employees-missing-tonia-edited.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>

                  <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>
                  <screen-link left="26.5%" top="40.5%" width="61%" height="7.5%" data-tgt="hb-employees-missing-tonia-edit-confirmed" @click.native="onLinkClick"></screen-link>


                  <select-box selection="Missing Information" :selections="employeeSelections" style="left:27%;top:30.5%;" @select="onSelectClick"></select-box>

                </div>

              </div>



                <div class="screen" data-screen="hb-employees-filters" :data-active="currentScreen=='hb-employees-filters'">
                    <img class="w-full max-w-100" src="/img/screens/hb-employees-all.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="5.4%" height="3%" data-tgt="hb-employees-all" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                        <filters-panel left="73.5%" top="30.4%" width="20%"  @close="setScreen('hb-employees-all')" @apply="onFilterEmployees"></filters-panel>
                    </div>

                </div>

                <!-- PLANS -->
                <div class="screen" data-screen="hb-plans" :data-active="currentScreen=='hb-plans'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="5.4%" height="3%" data-tgt="hb-employees-all" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                        <screen-link left="28%" top="42%" width="58%" height="11%" data-tgt="hb-plans-medical" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <div class="screen" data-screen="hb-plans-medical" :data-active="currentScreen=='hb-plans-medical'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans-medical.png" />
                    <div class="links">
                        <screen-link left="97%" top="8%" width="2.5%" height="4%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>

                        <select-box selection="MANAGERS" :selections="planClassificationsMedical" style="left:62.5%;top:24%;font-size:0.9em" @select="onSelectClick"></select-box>
                        <screen-link left="92.5%" top="24%" width="6.4%" height="4.5%" data-tgt="hb-plans-medical-management-downloaded-pdf" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>


              <div class="screen z-max" data-screen="hb-plans-medical-management-downloaded-pdf" :data-active="currentScreen=='hb-plans-medical-management-downloaded-pdf'">
                <img class="w-full max-w-100" src="/img/screens/hb-plans-medical-management-downloaded-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-plans-medical" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-plans-medical-hourly" :data-active="currentScreen=='hb-plans-medical-hourly'">
                <img class="w-full max-w-100" src="/img/screens/hb-plans-medical-hourly.png" />
                <div class="links">
                  <screen-link left="97%" top="8%" width="2.5%" height="4%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>

                  <select-box selection="EMPLOYEE" :selections="planClassificationsMedical" style="left:62.5%;top:24%;font-size:0.9em" @select="onSelectClick"></select-box>
                  <screen-link left="92.5%" top="24%" width="6.4%" height="4.5%" data-tgt="hb-plans-medical-hourly-downloaded-pdf" @click.native="onLinkClick"></screen-link>
                </div>
              </div>


              <div class="screen z-max" data-screen="hb-plans-medical-hourly-downloaded-pdf" :data-active="currentScreen=='hb-plans-medical-hourly-downloaded-pdf'">
                <img class="w-full max-w-100" src="/img/screens/hb-plans-medical-management-downloaded-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-plans-medical-hourly" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

                <div class="screen" data-screen="hb-plans-dental-class" :data-active="currentScreen=='hb-plans-dental-class'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans-dental-class.png" />
                    <div class="links">
                        <screen-link left="97%" top="8%" width="2.5%" height="4%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="25%" width="9%" height="4%" data-tgt="hb-plans-dental" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="30%" width="9%" height="4%" data-tgt="hb-plans-dental-class-employees" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="35.5%" width="9%" height="4%" data-tgt="hb-plans-dental-class-employees" @click.native="onLinkClick"></screen-link>
                        <screen-link left="93.5%" top="24%" width="6.4%" height="4.5%" data-tgt="hb-plans-dental-class-employees-output" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <div class="screen" data-screen="hb-plans-dental-class-employees" :data-active="currentScreen=='hb-plans-dental-class-employees'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans-dental-class-employees.png" />
                    <div class="links">
                        <screen-link left="97%" top="8%" width="2.5%" height="4%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="25%" width="9%" height="4%" data-tgt="hb-plans-dental-class" @click.native="onLinkClick"></screen-link>
                        <screen-link left="93.5%" top="24%" width="6.4%" height="4.5%" data-tgt="hb-plans-dental-class-employees-output" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <div class="screen" data-screen="hb-plans-dental-class-employees-output" :data-active="currentScreen=='hb-plans-dental-class-employees-output'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans-dental-class-employees-output.png" />
                    <div class="links">
                        <screen-link left="97%" top="8%" width="2.5%" height="4%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link left="63%" top="25%" width="9%" height="4%" data-tgt="hb-plans-dental-class" @click.native="onLinkClick"></screen-link>

                        <screen-link left="98%" top="25%" width="2.0%" height="3.5%" data-tgt="hb-plans-dental-class-employees" @click.native="onLinkClick"></screen-link>
                        <screen-link left="88.5%" top="29.5%" width="8.0%" height="5%" data-tgt="hb-plans-dental-pdf" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <div class="screen z-max" data-screen="hb-plans-dental-pdf" :data-active="currentScreen=='hb-plans-dental-pdf'">
                    <img class="w-full max-w-100" src="/img/screens/hb-plans-dental-pdf.png" />
                    <div class="links">

                        <screen-link left="0" top="0" width="100%" height="100%" data-tgt="hb-plans-dental-class-employees" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

                <!-- HISTORY -->
                <div class="screen" data-screen="hb-history" :data-active="currentScreen=='hb-history'">
                    <img class="w-full max-w-100" src="/img/screens/hb-history.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-overview" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="5.4%" height="3%" data-tgt="hb-employees-all" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="25.9%" top="18.5%" width="3.3%" height="3%" data-tgt="hb-plans" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="29.5%" top="18.5%" width="3.9%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>


              <!-- ENROLLMENT -->



              <div class="screen" data-screen="hb-enrollment-begin" :data-active="currentScreen=='hb-enrollment-begin'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-begin.png" />
                <div class="links">
                  <screen-link left="78%" top="64%" width="7%" height="6%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dependents" :data-active="currentScreen=='hb-enrollment-dependents'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents.png" />
                <div class="links">
                  <screen-link left="79%" top="60%" width="7%" height="6%" data-tgt="hb-enrollment-dependents-add" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dependents-add" :data-active="currentScreen=='hb-enrollment-dependents-add'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add.png" />
                <div class="links">
                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
                  <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
                  <screen-link left="63%" top="20%" width="35%" height="60%" data-tgt="hb-enrollment-dependents-add-husband" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dependents-add-husband" :data-active="currentScreen=='hb-enrollment-dependents-add-husband'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add-husband.png" />
                <div class="links">
                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
                  <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91.2%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents-add-husband-save" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dependents-add-husband-save" :data-active="currentScreen=='hb-enrollment-dependents-add-husband-save'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add-husband-save.png" />
                <div class="links">
                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents-husband-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91.2%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents-add-husband" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dependents-husband-added" :data-active="currentScreen=='hb-enrollment-dependents-husband-added'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-husband-added.png" />
                <div class="links">
                  <screen-link left="80%" top="77%" width="7%" height="6%" data-tgt="hb-enrollment-medical" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-medical" :data-active="currentScreen=='hb-enrollment-medical'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical.png" />
                <div class="links">
                  <screen-link left="79.5%" top="60%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-medical-uhc" :data-active="currentScreen=='hb-enrollment-medical-uhc'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical-uhc.png" />
                <div class="links">
                  <screen-link left="79.5%" top="129%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-medical-uhc-selectspouse" :data-active="currentScreen=='hb-enrollment-medical-uhc-selectspouse'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical-uhc-selectspouse.png" />
                <div class="links">
                  <screen-link left="78%" top="129%" width="8%" height="6%" data-tgt="hb-enrollment-medical-uhc" @click.native="onLinkClick"></screen-link>
                  <screen-link left="27.5%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-dependents-husband-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-dental" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dental" :data-active="currentScreen=='hb-enrollment-dental'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dental.png" />
                <div class="links">
                  <screen-link left="79%" top="112.5%" width="7%" height="6%" data-tgt="hb-enrollment-dental-spouse" @click.native="onLinkClick"></screen-link>
                  <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-dental-spouse" :data-active="currentScreen=='hb-enrollment-dental-spouse'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dental-spouse.png" />
                <div class="links">
                  <screen-link left="77%" top="112.5%" width="9%" height="6%" data-tgt="hb-enrollment-dental" @click.native="onLinkClick"></screen-link>
                  <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-vision" :data-active="currentScreen=='hb-enrollment-vision'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-vision.png" />
                <div class="links">

                  <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-dental-spouse" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-life" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-life" :data-active="currentScreen=='hb-enrollment-life'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life.png" />
                <div class="links">

                  <screen-link left="27.5%" top="78.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="60.5%" width="5.5%" height="5.0%" data-tgt="hb-enrollment-life-select" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-life-select" :data-active="currentScreen=='hb-enrollment-life-select'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life-select.png" />
                <div class="links">

                  <screen-link left="27.5%" top="100%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
                  <screen-link left="28%" top="86%" width="12%" height="7%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-life-select-100000" :data-active="currentScreen=='hb-enrollment-life-select-100000'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life-select-100000.png" />
                <div class="links">

                  <screen-link left="27.5%" top="100%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="100%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <flex-info left="39.75%" top="78%">The selected amount will be pending approval from the carrier before being added to your per pay period total.</flex-info>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries" :data-active="currentScreen=='hb-enrollment-beneficiaries'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries.png" />
                <div class="links">

                  <screen-link left="27.5%" top="84%" width="6.5%" height="6%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>
                  <screen-link left="79%" top="69%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries-add" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-add" :data-active="currentScreen=='hb-enrollment-beneficiaries-add'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add.png" />
                <div class="links">

                  <screen-link left="63%" top="14%" width="36%" height="7%" data-tgt="hb-enrollment-beneficiaries-add-primary" @click.native="onLinkClick"></screen-link>
                  <screen-link left="85.25%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary.png" />
                <div class="links">


                  <screen-link left="87%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="92%" top="29%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary-selected" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-selected" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-selected'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-selected.png" />
                <div class="links">


                  <screen-link left="87%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="93%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-add-primary-distribution" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="90%" top="29%" width="8.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-distribution" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-distribution'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-distribution.png" />
                <div class="links">


                  <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="88%" top="35%" width="8.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary-distribution-100" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-distribution-100" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-distribution-100'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-distribution-100.png" />
                <div class="links">


                  <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
                  <screen-link left="91%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-added" :data-active="currentScreen=='hb-enrollment-beneficiaries-added'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-added.png" />
                <div class="links">

                  <screen-link left="79%" top="69%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries-edit" @click.native="onLinkClick"></screen-link>
                  <screen-link left="27.5%" top="104%" width="6.5%" height="6%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="104%" width="7%" height="5.75%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-beneficiaries-edit" :data-active="currentScreen=='hb-enrollment-beneficiaries-edit'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-edit.png" />
                <div class="links">

                  <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-review" :data-active="currentScreen=='hb-enrollment-review'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review.png" />
                <div class="links">

                  <screen-link left="79%" top="59%" width="7%" height="5.75%" data-tgt="hb-enrollment-change-medical" @click.native="onLinkClick"></screen-link>
                  <screen-link left="79%" top="85.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-edit-beneficiary" @click.native="onLinkClick"></screen-link>

                  <screen-link left="27.5%" top="120.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="57%" top="120.5%" width="3%" height="5.75%" data-tgt="hb-enrollment-review-accept" @click.native="onLinkClick"></screen-link>
                  <screen-link left="70.5%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-legal-notice" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-change-medical" :data-active="currentScreen=='hb-enrollment-change-medical'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-change-medical.png" />
                <div class="links">

                  <screen-link left="73%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-review-edit-beneficiary" :data-active="currentScreen=='hb-enrollment-review-edit-beneficiary'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-edit-beneficiary.png" />
                <div class="links">

                  <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-review-legal-notice" :data-active="currentScreen=='hb-enrollment-review-legal-notice'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-legal-notice.png" />
                <div class="links">


                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-review-accept" :data-active="currentScreen=='hb-enrollment-review-accept'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-accept.png" />
                <div class="links">

                  <screen-link left="79%" top="59%" width="7%" height="5.75%" data-tgt="hb-enrollment-change-medical" @click.native="onLinkClick"></screen-link>
                  <screen-link left="79%" top="85.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-edit-beneficiary" @click.native="onLinkClick"></screen-link>

                  <screen-link left="27.5%" top="120.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="57%" top="120.5%" width="3%" height="5.75%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
                  <screen-link left="70.5%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-legal-notice" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-enrollment-confirmation" :data-active="currentScreen=='hb-enrollment-confirmation'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation.png" />
                <div class="links">

                  <screen-link left="50%" top="50%" width="15%" height="5%" data-tgt="hb-enrollment-confirmation-pdf" @click.native="onLinkClick"></screen-link>
                  <screen-link left="54%" top="55%" width="6.5%" height="5.75%" data-tgt="hb-employee-post-enrollment" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen z-max" data-screen="hb-enrollment-confirmation-pdf" :data-active="currentScreen=='hb-enrollment-confirmation-pdf'">
                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>


                </div>
              </div>

              <div class="screen" data-screen="hb-employee-post-enrollment" :data-active="currentScreen=='hb-employee-post-enrollment'">
                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment.png" />
                <div class="links">

                  <screen-link left="50%" top="50%" width="15%" height="5%" data-tgt="hb-enrollment-confirmation-pdf" @click.native="onLinkClick"></screen-link>
                  <screen-link left="54%" top="55%" width="6.5%" height="5.75%" data-tgt="hb-post-enrollment" @click.native="onLinkClick"></screen-link>


                </div>
              </div>







            </div>

          <!--EMPLOYEE PULLOUT TERRI -->

          <div class="pullout" data-screen="hb-employees-trent" :data-active="pulloutPanel=='hb-employees-trent'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

              <screen-link left="63.5%" top="33.5%" width="35%" height="6%" data-tgt="hb-employees-trent-plans-medical" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="39.5%" width="35%" height="7%" data-tgt="hb-employees-trent-plans-ENI" @click.native="showPullout"></screen-link>
            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-plans-medical" :data-active="pulloutPanel=='hb-employees-trent-plans-medical'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-plans.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-plans-ENI" :data-active="pulloutPanel=='hb-employees-trent-plans-ENI'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-plans-ENI.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-family" :data-active="pulloutPanel=='hb-employees-trent-family'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-family.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-history" :data-active="pulloutPanel=='hb-employees-trent-history'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-history.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-employee" :data-active="pulloutPanel=='hb-employees-trent-employee'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-employee.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <!--EMPLOYEE PULLOUT GAIL -->




          <div class="pullout" data-screen="hb-employees-gail" :data-active="pulloutPanel=='hb-employees-gail'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

              <screen-link left="63.5%" top="78.5%" width="35%" height="6%" data-tgt="hb-employees-gail-plans-dental" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="84%" width="35%" height="7%" data-tgt="hb-employees-gail-plans-vision" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="91%" width="35%" height="7%" data-tgt="hb-employees-gail-plans-ENI" @click.native="showPullout"></screen-link>
            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-dental" :data-active="pulloutPanel=='hb-employees-gail-plans-dental'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-dental.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-vision" :data-active="pulloutPanel=='hb-employees-gail-plans-vision'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-vision.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-ENI" :data-active="pulloutPanel=='hb-employees-gail-plans-ENI'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-ENI.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-family" :data-active="pulloutPanel=='hb-employees-gail-family'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-family.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-history" :data-active="pulloutPanel=='hb-employees-gail-history'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-history.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-employee" :data-active="pulloutPanel=='hb-employees-gail-employee'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-employee.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link dot-class="dot-top-center" left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link dot-class="dot-top-center" left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>


          <!-- HEADER NAV OVERLAYS -->


            <div class="overlay" data-screen="news" :data-active="overlayPanel=='news'">
                <img class="w-full max-w-100" src="/img/screens/sidepanel-news.png" />
                <div class="links">
                    <screen-link left="87%" top="1.5%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>



                </div>
            </div>

            <div class="overlay" data-screen="messages" :data-active="overlayPanel=='messages'">
                <img class="w-full max-w-100" src="/img/screens/sidepanel-messages.png" />
                <div class="links">
                    <screen-link left="90%" top="1%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>

                </div>
            </div>


            <flex-nav-top-bar class="z-40" :data-hidden="!visibility.topnav"  @nav-click="onTopNavLink"></flex-nav-top-bar>
            <flex-side-nav :data-hidden="!visibility.topnav" @nav-click="onSideNavLink" :active-link="sideNavLink" :mode="sideNavMode"></flex-side-nav>
        </div>
      <demo-menu v-if="showMenu"></demo-menu>
    </div>

</template>

<script>
    import ScreenLink from "../components/ScreenLink";
    import FiltersPanel from "../components/FiltersPanel";

    import FlexNavTopBar from "../components/FlexNavTopBar";
    import FlexSideNav from "../components/FlexAdminSideNav";
    //import InfoBox from "../components/InfoBox";
    import SelectBox from "@/components/SelectBox";
    import FlexInfo from "@/components/FlexInfo";
    import DemoMenu from "@/components/DemoMenu";
    export default {
        name: "admin-screens",
        components: {DemoMenu, FlexInfo, SelectBox, FlexSideNav, FlexNavTopBar,  FiltersPanel, ScreenLink},
        mounted: function(){
            window.addEventListener('keydown',this.onKeyDown);
            window.addEventListener('keyup',this.onKeyUp);
        },
        props: {},
        data: function () {
            return {
                defaultScreen: 'dashboard',
                visibility: {
                    topnav: true
                },
                overlayPanel: null,
                pulloutPanel: null,
                disableScreenScoll: false,
                showLinks: false,


                employeeSelections: [
                  { label: "All Employees", tgt: "hb-employees-all"},
                  { label: "Newly Eligible", tgt: "hb-employees-newly"},
                  { label: "Annual Enrollment", tgt: "hb-employees-annual"},
                  { label: "Current Enrollment", tgt: "hb-employees-current"},
                  { label: "Future Enrollment", tgt: "hb-employees-future"},
                  { label: "Missing Information", tgt: "hb-employees-missing"},

                ],

              planClassificationsMedical: [
                { label: "MANAGERS", tgt: "hb-plans-medical"},
                { label: "EMPLOYEE", tgt: "hb-plans-medical-hourly"},
              ]

            }
        },
        methods: {

            onSetGuided: function(guided){

                //this.guidedMode = guided;
               //this.showMenu = false;

               this.$store.commit("guidedMode", guided);
              this.$store.commit("showMenu", false);

            },

            onKeyDown: function(e){
                if(e.key == "Shift"){
                    this.showLinks = true;
                }

                if(e.key == " "){
                    this.$store.commit("showMenu", true);
                }
            },

            onKeyUp: function(e){
                console.log(e.key);
                if(e.key == "Shift"){
                    this.showLinks = false;
                }


            },

            onLinkClick: function(e){
               // this.currentScreen = e.target.dataset.tgt;

              if(!e.target.dataset.tgt && this.pulloutPanel) {
                this.pulloutPanel = null;
              }else if(e.target.dataset.isOverlay){
                this.overlayPanel = e.target.dataset.tgt
              }else{


                this.setScreen(e.target.dataset.tgt, e.target.dataset.tgtMode, e.target.dataset.tgtScrolltop);
              }


            },

          showPullout: function(e){
            // this.currentScreen = e.target.dataset.tgt;
            this.pulloutPanel = e.target.dataset.tgt
          },

          onSelectClick: function(tgt){
            // this.currentScreen = e.target.dataset.tgt;

              this.setScreen(tgt);



          },

            setScreen: function(id, mode, scrollToTop){
                this.overlayPanel = null;
                this.pulloutPanel = null;
                console.log(id, scrollToTop);

                if(!mode){
                  mode = "admin"
                }

                if(id == this.$route.params.screen){
                  //this.$router.go(0);
                }else{
                  this.$router.push({name: mode, params: { screen: id}});
                  if(scrollToTop){
                    this.$refs['screens'].scrollTo(0,0);
                    //window.scrollTo(0,0);
                  }
                }

            },

            onFilterEmployees: function(selections){
                console.log(selections);
                this.setScreen('hb-employees-all');
            },

            toggleViz: function(key){
                this.visibility[key] = !this.visibility[key];
            },

            onSideNavLink: function(link){
                if(link){
                    let linkParams = link.split(":");
                    if(linkParams[0] == "hb"){

                        this.$router.push({name: "admin", params: { screen: linkParams[1]}});

                    }else if(linkParams[0] == "dashboard"){

                        this.$router.push({name: "admin", params: { screen: linkParams[1]}});

                    }
                }

            },

            onTopNavLink: function(link){


                if(link){
                    let linkParams = link.split(":");
                    if(linkParams[0] == "pullout"){
                        this.showOverlay(linkParams[1]);

                    }
                }

            },

            showOverlay: function(id){
                this.overlayPanel = id;
            }
        },
        computed: {

          showMenu: function(){
            return this.$store.state.showMenu;
          },

          guidedMode: function(){
            return this.$store.state.guidedMode;
          },
            currentScreen: function(){
                if(this.$route.params.screen){
                    return this.$route.params.screen;
                }else{
                    return this.defaultScreen;
                }
            },

            sideNavLink: function(){
               if(this.$route.params.screen){
                   return this.$route.params.screen.split("-")[0];
               }else{
                   return "dashboard";
               }
            },

          sideNavMode: function(){
            if(this.$route.query.mode){
              return this.$route.query.mode;
            }else{
              return "admin";
            }
          }
        }
    }
</script>

<style scoped>

    img {
        margin: 0;
    }

    .demo-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0;
        padding-bottom: calc((920/1580) * 100%);
        max-width: 1580px;
        background-repeat: repeat-y;
        background-image: url(../assets/screen-bkg.png);
        background-size: 100% 10%;

        font-size: 1vw;
    }


    .demo {
        width: 100%;
        position: absolute;
        height: 100%;
        background-repeat: repeat-y;
        background-image: url(../assets/screen-bkg.png);
        background-size: 100% 10%;
        overflow-y:hidden;
        overflow-x: hidden;

    }

    .demo[data-noscroll="true"]{
        overflow-y: hidden;

    }



    .screens {

        position: relative;
        width: 100%;
        height: 100%;
        overflow-y:scroll;
        overflow-x: hidden;
    }

    .overlay {
        position: absolute;
        width: calc((320/1580) * 100%);
        top: calc((60/920) * 100%);
        right: 0;
        display: none;
    }

    .overlay[data-active="true"] {
        display: block;
    }

    .pullout {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      display: none;
      background-color: rgba(0,0,0,0.49);

    }

    .pullout[data-active="true"] {
      display: block;
    }

    .overlay[data-active="true"] {
      display: block;
    }

    .screens .screen {
        position: relative;
        width: 100%;
        display: none;
    }

    .screen[data-active="true"] {
        display: block;
    }

    .screen .links {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0;
        padding-top: calc((920/1580) * 100%);
    }

    .pullout .links {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 0;
      padding-top: calc((920/1580) * 100%);
    }


    /* UTILITIES */

    .w-full {
        width: 100%;
    }

    .max-w-100 {
        max-width: 1580px;
    }

    .pullout-1200 {
      position: absolute;
      width: calc(100% * (1200 / 3160));
      top: 0;
      right: 0;
    }

    .x-ray {
        opacity: 0.5;
    }

    *[data-hidden] {
        opacity: 0;
    }

    .demo[data-show-links="true"] .screen-link {
        border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .select-box {
      border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .flex-info {
      border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .info-box {
        display: block;
    }

    .demo .info-box {
        display: none;
    }


    .demo[data-guided="true"] .info-box {
        display: block;
    }

    .z-max {
        z-index: 50;
    }

    .z-20 {
      z-index: 20;
    }

    .z-40 {
        z-index: 40;
    }

    .info-box {
      z-index: 30;
    }

    .pullout {

    }





</style>